import MyBoardConnected from './MyBoardConnected'
export default MyBoardConnected
